import * as types from "./types";
import { 
    getNotificationAxios, 
    getPushNotificationAxios,
    putPushNotificationAxios
} from "./services";

export async function getNotificationsAction({commit}) {
    commit(types.LOADING_NOTIFICATION, true);
    try {
        const {data} = await getNotificationAxios();
        data.result = undefined ? [] : data.result;
        commit(types.GET_NOTIFICATION, data.result);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    commit(types.LOADING_NOTIFICATION, false);
}


export async function getPushNotificationAction({commit}) {
    commit(types.LOADING_PUSHNOTIFICATION, true);
    try {
        const {data} = await getPushNotificationAxios();
        console.log(data);
        commit(types.GET_PUSHNOTIFICATION, data);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    commit(types.LOADING_PUSHNOTIFICATION, false);
}

export async function putPushNotificationAction({commit}, id) {
    try {
        const {data} = await putPushNotificationAxios(id);
        console.log(data);
        commit(types.PUT_PUSHNOTIFICATION, data);
    }
    catch(e) {
        console.log(e);
        throw e;
    }
}
